export class WorkingShiftDateRangeHourRange {
  constructor(
    public hash?: string,
    public startTime?: number,
    public endTime?: number,
  ) { }

  clone() {
    return new WorkingShiftDateRangeHourRange(
      this.hash,
      this.startTime,
      this.endTime
    );
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/calendar/working-shift-date-range-hour-range.ts